/**
 * Session inactivity configuration
 *
 * To change the inactivity timeout duration, update INACTIVITY_TIMEOUT_MS below.
 * Examples:
 *   2 * 60 * 60 * 1000  →  2 hours
 *   6 * 60 * 60 * 1000  →  6 hours  (current)
 *  12 * 60 * 60 * 1000  → 12 hours
 */

/** How long a user can be inactive before being signed out (default: 6 hours) */
export const INACTIVITY_TIMEOUT_MS = 6 * 60 * 60 * 1000

/** How often the inactivity check runs in the background */
export const INACTIVITY_CHECK_INTERVAL_MS = 60 * 1000 // 1 minute

/** localStorage key used to store the last activity timestamp */
export const LAST_ACTIVITY_STORAGE_KEY = 'sc_last_activity'
